import Icon from '../components/Icon.vue'

Icon.register({
  'arrow-alt-circle-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504c-137 0-248-111-248-248s111-248 248-248 248 111 248 248-111 248-248 248zM372 212h-116v-70.9c0-10.7-13-16.1-20.5-8.5l-114.3 114.9c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5v-70.8h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-alt-circle-left.js
// module id = 616
// module chunks = 0